import { memo } from 'react';
import Button from './ui/Button';

/**
 * ResumeGameDialog Component
 * Shows when a saved game session is detected
 * Memoized to prevent unnecessary re-renders
 */
const ResumeGameDialog = memo(function ResumeGameDialog({
  session,
  onResume,
  onNewGame,
}) {
  if (!session) return null;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('da-DK', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-md w-full animate-fadeIn">
        <div className="text-center mb-6">
          <div className="text-6xl mb-4">🎮</div>
          <h2 className="text-3xl font-bold text-gray-800 mb-2">
            Fortsæt spil?
          </h2>
          <p className="text-gray-600">
            Du har et gemt spil fra {formatDate(session.savedAt)}
          </p>
        </div>

        {/* Session Details */}
        <div className="bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl p-6 mb-6">
          <div className="grid grid-cols-2 gap-4 text-center">
            <div>
              <div className="text-2xl font-bold text-purple-600">
                {session.score}
              </div>
              <div className="text-sm text-gray-600">Score</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-blue-600">
                {session.level}
              </div>
              <div className="text-sm text-gray-600">Niveau</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-orange-600">
                {session.streak}
              </div>
              <div className="text-sm text-gray-600">Streak</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-red-600">
                {session.lives}
              </div>
              <div className="text-sm text-gray-600">Liv</div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Button
            onClick={onResume}
            size="lg"
            fullWidth
          >
            Fortsæt Spil 🚀
          </Button>
          <Button
            onClick={onNewGame}
            variant="secondary"
            size="lg"
            fullWidth
          >
            Start Nyt Spil
          </Button>
        </div>
      </div>
    </div>
  );
});

export default ResumeGameDialog;
